<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@deletePromotion">Delete Promotion</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialogIcon" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
    <div class="text-center dialog-sub-title mat-caption">
        <span i18n="@@confirmDeletePromotion">Are you sure you want to delete the promotion code </span>"{{promotionCode}}"?
    </div>
    <button i18n="@@delete" data-testid="delete_promotion_button" class="w-100" mat-raised-button color="warn" (click)="deletePromotion()" i18n-aria-label="@@deletePromotionButton" aria-label="Delete Promotion">Delete</button>
</mat-dialog-content>